import _ from 'lodash';
import { getCountry } from '../iwIntlProvider/CountryProvider';

const OR = '|';

const one_letter_followed_by_either_one_or_two_numbers = '([A-Za-z][0-9]{1,2})';
const one_letter_followed_by_restricted_second_letter_and_one_or_two_numbers =
    '([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})';
const one_letter_followed_by_one_number_and_another_letter =
    '([A-Za-z][0-9][A-Za-z])';
const one_number_followed_by_two_letters = '([0-9][A-Za-z]{2})';
const one_letter_followed_by_restricted_second_letter_and_optional_number_and_letter =
    '([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])';

const first_postcode_part =
    '(' +
    one_letter_followed_by_either_one_or_two_numbers +
    OR +
    one_letter_followed_by_restricted_second_letter_and_one_or_two_numbers +
    OR +
    one_letter_followed_by_one_number_and_another_letter +
    OR +
    one_letter_followed_by_restricted_second_letter_and_optional_number_and_letter +
    ')';

const crown_first_postcode_part = '(GY|JE|IM)[0-9][0-9]?';

const postcodesUK =
    '(' + first_postcode_part + one_number_followed_by_two_letters + ')';

const crownPostcodeRegExpUK =
    '(' + crown_first_postcode_part + one_number_followed_by_two_letters + ')';

const GIR0AA = '([Gg][Ii][Rr]0[Aa]{2})';

const postodeRegExpUK = '^' + GIR0AA + OR + postcodesUK + '$';

export function verifyUKPostcode(postcode) {
    return isPostcodeValid(postcode, postodeRegExpUK);
}

export function verifyUKCrownPostcode(postcode) {
    return isPostcodeValid(postcode, crownPostcodeRegExpUK);
}

function isPostcodeValid(postcode, postcodeRegExp) {
    if (!_.isString(postcode)) {
        return false;
    }

    const reducedPostCode = postcode.replace(/ /g, '');
    const postcodeRegex = new RegExp(postcodeRegExp, 'igm');

    return postcodeRegex.test(reducedPostCode);
}

export function supportsAutoAddress() {
    return !_.includes(['DE'], getCountry());
}
